module.exports = __webpack_public_path__ + "PTMETTAservice-3.39dc60d7.png";